import React, { useEffect, useState, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { TextField } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux"
import AdviceSearchbar from './searchAdvice';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import RestoreIcon from '@material-ui/icons/Restore';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HealingIcon from '@material-ui/icons/Healing';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import SchoolIcon from '@material-ui/icons/School';
import WarningIcon from '@material-ui/icons/Warning';
import WorkIcon from '@material-ui/icons/Work';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import MoodBadIcon from '@material-ui/icons/MoodBad';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import LocalDrinkIcon from '@material-ui/icons/LocalDrink';
import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy';
import HotelIcon from '@material-ui/icons/Hotel';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import CloseIcon from '@material-ui/icons/Close';
import backPainIcon from '../../../Assets/Icons/back-pain_4986182.png';
import backIcon from '../../../Assets/Icons/back_9960742.png';
import breakIcon from '../../../Assets/Icons/break_14233381.png';
import medicineCustomIcon from '../../../Assets/Icons/medicine_14233378.png';
import painCustomIcon from '../../../Assets/Icons/pain_16491492.png';
import positionIcon from '../../../Assets/Icons/position_5064442.png';
import strainIcon from '../../../Assets/Icons/strain_3535097.png';
import stressRelieveIcon from '../../../Assets/Icons/stress-relieve_9960776.png';
import workingIcon from '../../../Assets/Icons/working_18483430.png';
import workCustomIcon from '../../../Assets/Icons/work_14233384.png';
import woundIcon from '../../../Assets/Icons/wound_16446847.png';
import back_9960742 from '../../../Assets/Icons/back_9960742.png';
import allergensIcon from '../../../Assets/Icons/allergen_5282067.png';
import taskIcon from '../../../Assets/Icons/task_2098313.png';
import cleaningIcon from '../../../Assets/Icons/cleaning-tools_17238896.png';

// Module-level cache so AdviceLibrary does not refetch across mounts/tabs
const adviceLibraryCache = {
  data: null,
};

const useStyles = makeStyles((theme) => ({
  libraryHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 6,
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    paddingLeft: 'clamp(10px, calc(2px + 0.625vw), 16px)',
    paddingRight: 'clamp(10px, calc(2px + 0.625vw), 16px)',
    paddingTop: 'clamp(8px, calc(1px + 0.55vw), 12px)',
    paddingBottom: 'clamp(8px, calc(1px + 0.55vw), 12px)',
    boxSizing: 'border-box',
    borderBottom: '2px solid #FF7F27',
  },
  libraryHeaderTitle: {
    color: '#002D55',
    fontWeight: 700,
    fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem) !important',
    position: 'absolute',
    left: 'clamp(10px, calc(2px + 0.625vw), 16px)',
    paddingLeft: 5,
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#FF7F27',
    },
    '& .MuiInputBase-input': {
      fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    },
    '& .MuiInputLabel-root': {
      fontSize: 'clamp(0.65rem, calc(1px + 0.72vw), 0.9rem)',
    },
  },
  addButton: {
    color: "#FF7F27", 
    backgroundColor: '#F0F8FF',
    marginBottom: 10,
    borderRadius: 12,
    '&:hover': {
      backgroundColor: '#e6eaf0', // light grey that fits the theme
      color: '#FF7F27',
      fontWeight: 'bold',
      maxHeight: 30,
      zIndex: 2
    },
  },
  alwaysShowSpinButtons: {
    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
      opacity: 1,
      pointerEvents: 'all',
      WebkitAppearance: 'auto',
    },
    // For Firefox
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  cardFiltered: {
    height: '97%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  cardOriginal: {
    height: '97%',
    display: 'flex',
    borderRadius: 18,
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  cardClickable: {
    cursor: 'pointer',
    transition: 'box-shadow 0.2s, border-color 0.2s',
    '&:hover': {
      boxShadow: '0 0 0 1px #FF7F27, 0 4px 16px rgba(255,127,39,0.18)',
      borderColor: '#FF7F27',
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  exerciseTypographyCardStyling: {
    flexGrow: 1,
    color: "#002D55",
    textAlign: "center",
    marginBottom: 0,
    fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 1.0rem) !important',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  // Apply brand-orange tint to raster icons (PNG/JPEG) via CSS filter
  iconImageOrange: {
    filter:
      'brightness(0) saturate(100%) invert(47%) sepia(72%) saturate(738%) hue-rotate(354deg) brightness(100%) contrast(697%)',
  },
  orangeSelect: {
    background: '#ffffff',
    color: '#002D55',
    fontWeight: 500,
    fontSize: 'clamp(0.69rem, 0.69vw, 0.93rem)',
    border: '1px solid #ccc',
    borderRadius: 14,
    padding: 'clamp(2.3px, 0.29vw, 3.5px) clamp(12px, 0.15vw, 18px)',
    paddingLeft: '0px !important', 
    cursor: 'pointer',
    outline: 'none',
    transition: 'border-color 0.2s',
    '& .MuiSelect-select': {
      padding: 'clamp(0px, 0.29vw, 0px) clamp(12px, 0.15vw, 24px) !important',
      minHeight: 'unset !important',
      lineHeight: 'normal',
    },
    '&:focus': {
      borderColor: '#FF7F27',
      outline: '#FF7F27 solid 1px',
    },
    '&:hover': {
      borderColor: '#FF7F27',
    },
  },
  largeCheckbox: {
    fontSize: 'clamp(20px, 1.7vw, 32px)',
  },
  menuItem: {
    fontSize: 'clamp(0.69rem, 0.69vw, 0.93rem)',
    color: '#002D55',
  },
  confirmButton: {
    backgroundColor: '#002D55',
    color: '#FFFFFF',
    borderRadius: 50,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(3px, 0.32vw, 6px) clamp(8px, 0.85vw, 16px)',
    fontSize: 'clamp(0.69rem, 0.75vw, 0.875rem)',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 'clamp(70px, 5.2vw, 100px)',
    '&:hover': {
      backgroundColor: '#FF7F27',
      boxShadow: 'none',
    },
  },
  cancelButton: {
    backgroundColor: '#e6eaf0',
    color: '#002D55',
    fontWeight: 'bold',
    borderRadius: 50,
    border: '2px solid transparent',
    boxShadow: 'none',
    padding: 'clamp(3px, 0.32vw, 6px) clamp(8px, 0.85vw, 16px)',
    fontSize: 'clamp(0.69rem, 0.75vw, 0.875rem)',
    textTransform: 'none',
    minWidth: 'clamp(70px, 5.2vw, 100px)',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#FF7F27',
      border: '2px solid #FF7F27',
      boxShadow: 'none',
    },
  },
  adviceEditDialogTitle: {
    borderBottom: '1px solid #eeeeee',
    padding: '16px 24px',
    backgroundColor: '#ffffff',
  },
  adviceEditDialogTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  adviceEditDialogTitleText: {
    flex: 1,
    color: '#002D55',
    fontWeight: 600,
    fontSize: 'clamp(0.95rem, calc(4px + 0.72vw), 1.15rem)',
  },
  adviceEditDialogCloseButton: {
    color: '#64748B',
    padding: 6,
  },
  adviceEditDialogContent: {
    padding: '24px !important',
    overflow: 'auto',
    backgroundColor: '#e6eaf0',
  },
  adviceEditDialogSectionLabel: {
    fontSize: 12,
    color: '#666666',
    marginBottom: 8,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  adviceEditDialogSectionPanel: {
    backgroundColor: '#f7faff',
    borderRadius: 18,
    padding: 16,
    marginBottom: 24,
    border: '1px solid #dce8f5',
  },
  adviceEditDialogField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 14,
      borderColor: '#dddddd',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
  },
  adviceEditDialogActions: {
    padding: '16px 24px',
    borderTop: '1px solid #eeeeee',
    backgroundColor: '#ffffff',
  },
}));

const FrequencyType = [
  {
    value: "daily",
    label: "Daily"
  },
  {
    value: "weekly",
    label: "Weekly"
  },
];

// Base URL for custom icons
const ICON_BASE_URL = 'https://api.virtus-one.com/static/icons/';

// Custom image icons (PNG files)
const customImageIcons = {
  'back-pain': backPainIcon,
  'back': backIcon,
  'break': breakIcon,
  'medicine-custom': medicineCustomIcon,
  'pain-custom': painCustomIcon,
  'position': positionIcon,
  'strain': strainIcon,
  'stress-relieve': stressRelieveIcon,
  'working': workingIcon,
  'work-custom': workCustomIcon,
  'wound': woundIcon,
  'allergens': allergensIcon,
  'cleaning': cleaningIcon,
  'chemicals': cleaningIcon,
};

// Icon mapping: keywords to icon components or image URLs
const iconMapping = {
  exercise: 'stress-relieve',
  fitness: DirectionsRunIcon,
  activity: DirectionsRunIcon,
  physical: DirectionsRunIcon,
  stretching: FitnessCenterIcon,
  training: DirectionsRunIcon,
  home: FitnessCenterIcon,
  homebased: FitnessCenterIcon,
  program: FitnessCenterIcon,
  workout: FitnessCenterIcon,
  health: LocalHospitalIcon,
  medical: LocalHospitalIcon,
  treatment: LocalHospitalIcon,
  specialist: LocalHospitalIcon,
  rest: RestoreIcon,
  recovery: RestoreIcon,
  sleep: HotelIcon,
  nap: HotelIcon,
  powernap: HotelIcon,
  relaxation: EmojiEmotionsIcon,
  mental: MoodBadIcon,
  stress: 'strain',
  psychological: MoodBadIcon,
  anxiety: MoodBadIcon,
  headache: 'break',
  migraine: 'break',
  pain: 'pain-custom',
  posture: 'position',
  prolonged: 'position',
  ergonomic: 'working',
  screen: DesktopWindowsIcon,
  computer: DesktopWindowsIcon,
  desk: DesktopWindowsIcon,
  minimize: DesktopWindowsIcon,
  wellness: FavoriteBorderIcon,
  prevention: 'stress-relieve',
  caution: 'stress-relieve',
  care: HealingIcon,
  therapy: HealingIcon,
  education: SchoolIcon,
  learning: SchoolIcon,
  water: LocalDrinkIcon,
  hydration: LocalDrinkIcon,
  drink: LocalDrinkIcon,
  fluid: LocalDrinkIcon,
  allergens: 'allergens',
  allergies: 'allergens',
  nutrition: RestaurantIcon,
  beverages: RestaurantIcon,
  medicine: 'medicine-custom',
  medication: 'medicine-custom',
  medications: 'medicine-custom',
  management: taskIcon,
  task: taskIcon,
  reminder: taskIcon,
  drug: LocalPharmacyIcon,
  pharmaceutical: LocalPharmacyIcon,
  trigger: 'chemicals',
  side: LocalPharmacyIcon,
  back: 'back',
  strain: 'strain',
  injury: 'wound',
  wound: 'wound',
  work: 'work-custom',
  break: 'break',
};

// Function to find icon for advice based on title
export const getAdviceIcon = (title) => {
  if (!title) return { type: 'component', value: AssignmentIcon }; // default icon
  
  const titleLower = title.toLowerCase();
  const words = titleLower.split(/\s+/);
  
  // Check each word in the title against the icon mapping
  for (const word of words) {
    if (iconMapping[word]) {
      const iconValue = iconMapping[word];
      // Check if it's a string (custom image key) or component
      if (typeof iconValue === 'string') {
        return { type: 'image', value: customImageIcons[iconValue] };
      }
      return { type: 'component', value: iconValue };
    }
  }
  
  // Check if any mapping key is contained in the title
  for (const key in iconMapping) {
    if (titleLower.includes(key)) {
      const iconValue = iconMapping[key];
      if (typeof iconValue === 'string') {
        return { type: 'image', value: customImageIcons[iconValue] };
      }
      return { type: 'component', value: iconValue };
    }
  }
  
  return { type: 'component', value: AssignmentIcon }; // default icon if no match
};

export default function AdviceLibrary({ onAddAdvice, handleRemoveAdviceFrontend }) {
  const classes = useStyles();
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const [isLoading, setIsLoading] = useState(false);
  const token = useSelector(state => state.auth.token);
  const [frequencyType, setFrequencyType] = React.useState();
  const [exercises, setExercises] = useState([]);
  const [advices, setAdvices] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [filteredAdvices, setFilteredAvices] = useState([]);
  const [filterIdentifier, setFilterIdentifier] = useState('');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedAdvice, setSelectedAdvice] = useState(null);
  const [editedParams, setEditedParams] = useState({ sets: 3, repetitions: 10, time: 30, pause: 15, frequencyType: "daily", frequency: 1, title: "", advice: "", importance: 1 });
  const [editModalViewOnly, setEditModalViewOnly] = useState(false);
  const [selectedAdviceIds, setSelectedAdviceIds] = useState(new Set());
  const [queueAdvices, setQueueAdvices] = useState([]);
  const [queueIndex, setQueueIndex] = useState(0);
  const [queueParamsArray, setQueueParamsArray] = useState([]);

  useEffect(() => {
    if (advices !== undefined) {
      let filtered = advices.filter(advice =>
        advice.title.toLowerCase().includes(searchInput.toLowerCase())
      );
      if (filterIdentifier) filtered = filtered.filter(a => a.identifier === filterIdentifier);
      setFilteredAvices([...new Set(filtered)]);
    }
  }, [advices, searchInput, filterIdentifier]);

  // Derive readable label from camelCase identifier
  const formatIdentifier = (id) => {
    if (!id) return id;
    return id
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .replace(/^./, s => s.toUpperCase());
  };

  const uniqueIdentifiers = useMemo(() => [
    ...new Set(advices.filter(a => a.identifier).map(a => a.identifier))
  ], [advices]);

  const handleChange = event => {
    setFrequencyType(event.target.value);
    setFilteredAvices(
      [...new Set(advices.filter(advice => advice.frequency_type === event.target.value && advice.title.toLowerCase().includes(searchInput.toLowerCase())))],
    );
  };

  // Open modal and initialize params when Add is clicked
  const handleOpenEditModal = (exercise) => {
    setSelectedAdvice(exercise);
    setEditedParams({
      sets: exercise.sets ?? 3,
      repetitions: exercise.repetitions ?? 10,
      time: typeof exercise.time === "string" ? parseInt(exercise.time) || parseInt((exercise.time || "").split("_")[0]) || 30 : exercise.time ?? 30,
      pause: typeof exercise.pause === "string" ? parseInt(exercise.pause) || parseInt((exercise.pause || "").split("_")[0]) || 15 : exercise.pause ?? 15,
      frequencyType: exercise.frequencyType ?? "daily",
      frequency: exercise.frequency ?? 1,
      index: exercise.index ?? 1,
      title: exercise.title ?? "",
      advice: exercise.advice ?? "",
      importance: exercise.importance ?? 1,
    });
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditModalViewOnly(false);
    setSelectedAdvice(null);
    setQueueAdvices([]);
    setQueueParamsArray([]);
    setQueueIndex(0);
  };

  const handleParamChange = (field, value) => {
    const parsed = (field === "time" || field === "pause") ? parseInt(value, 10) || 0 : value;
    setEditedParams(prev => ({ ...prev, [field]: parsed }));
    if (queueAdvices.length > 0) {
      setQueueParamsArray(prev => {
        const next = [...prev];
        next[queueIndex] = { ...next[queueIndex], [field]: parsed };
        return next;
      });
    }
  };

  const handleConfirmAdd = () => {
    if (selectedAdvice) {
      onAddAdvice({ ...selectedAdvice, ...editedParams });
      handleCloseEditModal();
    }
  };

  const handleToggleSelect = (e, adviceId) => {
    if (e) e.stopPropagation();
    setSelectedAdviceIds(prev => {
      const next = new Set(prev);
      if (next.has(adviceId)) next.delete(adviceId);
      else next.add(adviceId);
      return next;
    });
  };

  const handleOpenQueueModal = () => {
    const queue = filteredAdvices.filter(a => selectedAdviceIds.has(a.id));
    if (queue.length === 0) return;
    if (queue.length === 1) {
      handleOpenEditModal(queue[0]);
      setSelectedAdviceIds(new Set());
      return;
    }
    const params = queue.map(a => ({
      title: a.title ?? "",
      advice: a.advice ?? "",
      importance: a.importance ?? 1,
      frequencyType: a.frequencyType ?? "daily",
      frequency: a.frequency ?? 1,
    }));
    setQueueAdvices(queue);
    setQueueParamsArray(params);
    setQueueIndex(0);
    setSelectedAdvice(queue[0]);
    setEditedParams(params[0]);
    setEditModalOpen(true);
  };

  const handleNextInQueue = () => {
    const nextIndex = queueIndex + 1;
    setQueueIndex(nextIndex);
    setSelectedAdvice(queueAdvices[nextIndex]);
    setEditedParams({ ...queueParamsArray[nextIndex] });
  };

  const handleConfirmAll = () => {
    queueParamsArray.forEach((params, i) => {
      onAddAdvice({ ...queueAdvices[i], ...params });
    });
    setSelectedAdviceIds(new Set());
    handleCloseEditModal();
  };

  const fetchAdvices = async () => {
    // Serve from cache if available
    if (adviceLibraryCache.data) return adviceLibraryCache.data;
    if (!token || (typeof token === 'string' && token.trim() === '')) return null;
    try {
      const response = await fetch('https://api.virtus-one.com/treatment/all_advices/', {
        headers: {
          Authorization: `Token ${token}`,
        },
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();
        adviceLibraryCache.data = data;
        return data;
      } else {
        throw new Error('Failed to fetch advices');
      }
    } catch (error) {
      console.error('AdviceLibrary fetch failed', error);
      return null;
    }
  };

  //const fetchExercises = async () => {
  //  try {
  //    setIsLoading(true);
  //    const response = await fetch("https://api.virtus-one.com/treatment/all_exercises/",  {
  //      headers: {
  //        "Authorization": `Token ${token}`
  //      },
  //      method: "GET",
  //    });
//  
  //    if (response.ok) {
  //      const data = await response.json();
  //      console.log(data)
  //      return data;
  //    } else {
  //      throw new Error("Failed to fetch exercises");
  //    }
  //  } catch (error) {
  //    if (!didCancel) {
  //      setIsLoading(false);
  //      alert("ERROR: " + error.message);
  //    }
  //  }
  //};

  // Ref to track if advice library has been fetched (global data, fetch once ever)
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    // Skip if already fetched - advice library is global and doesn't change per patient
    if (hasFetchedRef.current) return;
    // If cache exists, use it and skip network
    if (adviceLibraryCache.data) {
      setAdvices(adviceLibraryCache.data);
      hasFetchedRef.current = true;
      return;
    }
    
    let cancelled = false;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchAdvices();
        if (!cancelled && data) {
          console.log('Data before setting advices state: ', data);
          setAdvices(data);
          hasFetchedRef.current = true; // Mark as fetched
        }
      } catch (error) {
        console.error(error);
        alert(`Error: ${error.message}`);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    // Fetch only once per component lifetime - advice library is global data
    fetchData();
    return () => {
      cancelled = true;
    };
  }, [token]);
  
  

  
  
  
  return (
    <Card style={{ background: '#f7faff', borderRadius: 16, paddingBottom: "3%", boxShadow: '0 6px 32px rgba(0,45,85,0.18)', overflow: 'hidden' }}>
      <CssBaseline />
      <div className={classes.libraryHeader}>
        <Typography variant="h6" className={classes.libraryHeaderTitle}>
          Advice library
        </Typography>
        <AdviceSearchbar
          searchInput={searchInput}
          setSearchInput={setSearchInput} 
          setAdvices={setAdvices}
          advices={advices}
        />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '8px 10px', marginBottom: 8 }}>
        <Select disableUnderline displayEmpty value={filterIdentifier} onChange={e => setFilterIdentifier(e.target.value)} className={classes.orangeSelect}
          style={{ maxWidth: 200 }}
          MenuProps={{ getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, PaperProps: { style: { borderRadius: 14, marginTop: 4 } } }}>
          <MenuItem value="" className={classes.menuItem}><em>All Topics</em></MenuItem>
          {uniqueIdentifiers.map(id => <MenuItem key={id} value={id} className={classes.menuItem}>{formatIdentifier(id)}</MenuItem>)}
        </Select>
        {selectedAdviceIds.size > 0 && (
          <Box display="flex" alignItems="center" style={{ marginLeft: 'auto', gap: 8 }}>
            <Typography style={{ color: '#002D55', fontSize: 13, fontWeight: 600 }}>
              {selectedAdviceIds.size} selected
            </Typography>
            <Button
              size="small"
              variant="contained"
              style={{ backgroundColor: '#FF7F27', color: '#fff', borderRadius: 8, textTransform: 'none', fontWeight: 700, boxShadow: 'none' }}
              onClick={handleOpenQueueModal}
            >
              Add Selected
            </Button>
            <Button
              size="small"
              style={{ color: '#002D55', textTransform: 'none', padding: '2px 8px' }}
              onClick={() => setSelectedAdviceIds(new Set())}
            >
              Clear
            </Button>
          </Box>
        )}
      </div>
      <main>
        {/* Hero unit */}
        <Container className={classes.cardGrid} maxWidth="md" style={{ minHeight: '50vh' }}>
          {/* End hero unit */}
          <Grid container spacing={2} >
            {filteredAdvices.length === 0 ? (
              <Grid item xs={12}>
                <Typography style={{ color: '#002D55', opacity: 0.4, textAlign: 'center', padding: '40px 0', fontSize: 'clamp(0.8rem, 1.2vw, 1.01rem)' }}>
                  No advice matches the current filters.
                </Typography>
              </Grid>
            ) : filteredAdvices.map((advice) => {
              const iconData = getAdviceIcon(advice.title);
              return (
                <Grid item key={advice.id} xs={6} sm={4} md={4} lg={4} xl={3}>
                  <div style={{ position: 'relative' }}>
                    <div style={{
                      position: 'absolute', top: 9, left: 9, zIndex: 2,
                      borderRadius: 16,
                      overflow: 'hidden', lineHeight: 0,
                    }}>
                      <Checkbox
                        checked={selectedAdviceIds.has(advice.id)}
                        onChange={e => handleToggleSelect(e, advice.id)}
                        onClick={e => e.stopPropagation()}
                        className={classes.largeCheckbox}
                        size="small"
                        icon={
                          <span style={{
                            display: 'inline-block', boxSizing: 'border-box',
                            width: '1em', height: '1em',
                            border: '2px solid currentColor', borderRadius: 16,
                          }} />
                        }
                        checkedIcon={
                          <span style={{
                            display: 'inline-flex', boxSizing: 'border-box',
                            width: '1em', height: '1em',
                            background: 'currentColor', borderRadius: 16,
                            alignItems: 'center', justifyContent: 'center',
                          }}>
                            <svg viewBox="0 0 24 24" style={{ width: '0.7em', height: '0.7em', fill: '#fff' }}>
                              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                            </svg>
                          </span>
                        }
                        style={{
                          padding: 4, fontSize: 'clamp(13px, 1.2vw, 23px)', color: selectedAdviceIds.has(advice.id) ? '#0fbb51' : '#002D55',
                        }}
                      />
                    </div>
                    <Button
                      size="small"
                      className={classes.addButton}
                      onClick={e => {
                        e.stopPropagation();
                        setEditModalViewOnly(selectedAdviceIds.size > 0);
                        handleOpenEditModal(advice);
                      }}
                      style={{ position: 'absolute', top: 9, right: 9, zIndex: 2, minWidth: 0, padding: '2px 7px', marginBottom: 0, fontSize: 'clamp(0.45rem, 0.7vw, 0.82rem)' }}
                    >
                      View
                    </Button>
                  <Card
                    className={`${classes.cardOriginal} ${classes.cardClickable}`}
                    onClick={() => {
                      if (selectedAdviceIds.size > 0) {
                        handleToggleSelect(null, advice.id);
                      } else {
                        handleOpenEditModal(advice);
                      }
                    }}
                    style={selectedAdviceIds.has(advice.id) ? { boxShadow: '0 0 0 2px #FF7F27' } : {}}
                  >
                  <div style={{ padding: 'clamp(7px, 0.63vw, 12px)', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'clamp(56px, 4.78vw, 92px)', backgroundColor: '#F0F8FF' }}>
                    {iconData.type === 'image' ? (
                      <img src={iconData.value} alt="" className={classes.iconImageOrange} style={{ width: 'clamp(20px, 2.2vw, 41px)', height: 'clamp(20px, 2.2vw, 41px)', objectFit: 'contain' }} />
                    ) : (
                      <iconData.value style={{ fontSize: 'clamp(20px, 2.2vw, 41px)', color: '#FF7F27' }} />
                    )}
                  </div>
                  <CardContent className={classes.cardContent} style={{ flex: 1, minHeight: 'clamp(86px, calc(14px + 5.25vw), 115px)' }}>
                      <Typography gutterBottom className={classes.exerciseTypographyCardStyling} >
                        {advice.title}
                      </Typography>
                  </CardContent>

                </Card>
                  </div>
              </Grid>
              );
            })}
          </Grid>
        </Container>
        {/* Modal for editing advice parameters */}
        <Dialog open={editModalOpen} onClose={handleCloseEditModal} fullWidth PaperProps={{ style: { borderRadius: 18, maxWidth: 800 } }}>
          <DialogTitle className={classes.adviceEditDialogTitle}>
            <Box className={classes.adviceEditDialogTitleRow}>
              <Typography className={classes.adviceEditDialogTitleText}>{editModalViewOnly ? 'View Advice' : 'Add Advice to Program'}</Typography>
              {queueAdvices.length > 1 && (
                <span style={{ fontSize: 'clamp(0.62rem, 0.7vw, 0.81rem)', fontWeight: 700, color: '#002D55', background: '#e6eaf0', borderRadius: 12, padding: '3px 12px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                  {queueIndex + 1} / {queueAdvices.length}
                </span>
              )}
              <IconButton onClick={handleCloseEditModal} className={classes.adviceEditDialogCloseButton}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.adviceEditDialogContent}>
            {selectedAdvice && (
              <>
                <Typography className={classes.adviceEditDialogSectionLabel}>Advice details</Typography>
                <Box className={classes.adviceEditDialogSectionPanel}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Title"
                        fullWidth
                        value={editedParams.title}
                        onChange={(e) => !editModalViewOnly && handleParamChange('title', e.target.value)}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true, style: { color: '#002D55' } }}
                        InputProps={{ style: { color: '#002D55', fontWeight: 600 }, readOnly: editModalViewOnly }}
                        className={`${classes.orangeFocused} ${classes.adviceEditDialogField}`}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Advice"
                        multiline
                        minRows={3}
                        maxRows={6}
                        fullWidth
                        value={editedParams.advice}
                        onChange={(e) => !editModalViewOnly && handleParamChange('advice', e.target.value)}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true, style: { color: '#002D55' } }}
                        InputProps={{ style: { color: '#002D55', fontWeight: 400, minHeight: 80 }, readOnly: editModalViewOnly }}
                        className={`${classes.orangeFocused} ${classes.adviceEditDialogField}`}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Typography className={classes.adviceEditDialogSectionLabel}>Ordering</Typography>
                <Box className={classes.adviceEditDialogSectionPanel} style={{ marginBottom: 0 }}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Index / Importance (Lower numbers appear first)"
                        type="number"
                        fullWidth
                        value={editedParams.importance}
                        onChange={(e) => !editModalViewOnly && handleParamChange('importance', parseInt(e.target.value, 10) || 1)}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true, style: { color: '#002D55' } }}
                        InputProps={{ style: { color: '#002D55', fontWeight: 600 }, inputProps: { min: 1 }, readOnly: editModalViewOnly }}
                        className={`${classes.orangeFocused} ${classes.adviceEditDialogField}`}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions className={classes.adviceEditDialogActions}>
            {editModalViewOnly ? (
              <Button onClick={handleCloseEditModal} variant="contained" className={classes.cancelButton}>
                Close
              </Button>
            ) : (
              <>
                <Button onClick={handleCloseEditModal} variant="contained" className={classes.cancelButton}>
                  Cancel
                </Button>
                {queueAdvices.length > 1 ? (
                  queueIndex < queueAdvices.length - 1 ? (
                    <Button onClick={handleNextInQueue} variant="contained" className={classes.confirmButton}>
                      Next →
                    </Button>
                  ) : (
                    <Button onClick={handleConfirmAll} variant="contained" className={classes.confirmButton}>
                      Add All
                    </Button>
                  )
                ) : (
                  <Button onClick={handleConfirmAdd} variant="contained" className={classes.confirmButton}>
                    Confirm
                  </Button>
                )}
              </>
            )}
          </DialogActions>
        </Dialog>
      </main>
    </Card>
  );
} 